/*
 * @Author: Jason
 * @Date: 2019-10-15 17:32:50
 * @version: 
 * @LastEditors: Jason
 * @LastEditTime: 2019-10-29 14:35:01
 * @Descripttion: 
 */
import { POST,GET } from '../assets/js/utils'
import qs from "qs"

const URL = {

    WxPay:'/sdcar/payConfirm-wx', // 微信支付接口
    NhPay:'/sdcar/payConfirm-nh', // 农行支付接口
    OrderList:'/sdcar/order-list', // 订单列表接口
    OrderQuery:'/sdcar/order-query', // 订单详情列表接口
}




function GetWxPay(pars = {}){
    return POST(URL.WxPay,qs.stringify(pars),1,"application/x-www-form-urlencoded")
}
function GetNhPay(pars = {}){
    return POST(URL.NhPay,qs.stringify(pars),1,"application/x-www-form-urlencoded")
}
function GetOrderQuery(pars = {}){
    return POST(URL.OrderQuery,qs.stringify(pars),1,"application/x-www-form-urlencoded")
}
function GetOrderList(pars = {}){
    return POST(URL.OrderList,qs.stringify(pars),1,"application/x-www-form-urlencoded")
}





export { 
    GetWxPay,GetNhPay,GetOrderList,GetOrderQuery
}